<template>
  <div class="tagname-wrap">
    <div class="header"><span>命名解析管理</span></div>
    <div class="container">
      <div class="filter">
        <el-form :inline="true" :model="filterData" class="demo-form-inline">
          <el-form-item label="规则名称">
            <el-input v-model="filterData.ruleName" placeholder="请输入规则名称"></el-input>
          </el-form-item>
          <el-form-item label="类型">
            <el-select v-model="filterData.type" multiple placeholder="请选择类型">
              <el-option v-for="item in materialRuleTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建人">
            <el-select
              clearable
              popper-class="BI-select BI-select-product report_select"
              v-model="filterData.creatorList"
              filterable
              collapse-tags
              class="all-select"
              multiple
              placeholder="请选择创建人"
            >
              <el-option v-for="item in creatorList" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="更新人">
            <el-select
              clearable
              popper-class="BI-select BI-select-product report_select"
              v-model="filterData.reviserList"
              filterable
              class="all-select"
              collapse-tags
              multiple
              placeholder="请选择更新人"
            >
              <el-option v-for="item in reviserList" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch">查询</el-button>
            <el-button @click="handleReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-button type="primary" @click="handleAdd">新建</el-button>
      <div class="table">
        <el-table id="rebateSetTable" v-loading="loading" :data="tableData" style="width: 100%" height="100%">
          <el-table-column label="规则名称" prop="ruleName"> </el-table-column>
          <el-table-column label="类型" prop="type" width="100px">
            <template slot-scope="scope">
              {{ materialRuleTypeOptions.find((item) => item.value == scope.row.type).label }}
            </template>
          </el-table-column>
          <el-table-column label="创建人" prop="creator"> </el-table-column>
          <el-table-column label="更新人" prop="reviser"> </el-table-column>
          <el-table-column label="创建时间" prop="createTime"> </el-table-column>
          <el-table-column label="更新时间" prop="modifyTime"> </el-table-column>
          <el-table-column label="备注" prop="remark" width="350px"></el-table-column>
          <el-table-column label="操作" prop="operate" width="200px">
            <template slot-scope="scope">
              <el-button type="text" @click="editData(scope.row)">编辑</el-button>
              <el-button type="text" @click="copyData(scope.row)">复制</el-button>
              <el-button type="text" @click="delData(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <self-pagination
          :total="pageData.total"
          :pageSize="pageData.size"
          :currentPage="pageData.page"
          ref="tabelPagination"
          @getCurrentPage="changePage"
          @handleSizeChange="changePageSize"
        ></self-pagination>
      </div>
    </div>
    <add-rule-modal ref="ruleModal" @callBackSuccess="handleSearch"></add-rule-modal>
  </div>
</template>

<script>
import AddRuleModal from "./AddRuleModal.vue";
import { materialRuleTypeOptions } from "@/config/fieldData";
import { queryAnalysisList, getTagCreatorList, getTagReviserList, deleteAnalysis } from "@/api/property";
export default {
  components: {
    AddRuleModal,
  },

  data() {
    return {
      materialRuleTypeOptions,
      filterData: {
        ruleName: "",
        type: [],
        creatorList: [],
        reviserList: [],
      },
      creatorList: [],
      reviserList: [],

      loading: false,
      tableData: [],
      pageData: {
        total: 0,
        size: 10,
        page: 1,
      },
    };
  },

  computed: {},

  watch: {},

  mounted() {
    this.getList();
    this.initSelect();
  },

  methods: {
    initSelect() {
      getTagCreatorList().then((res) => {
        this.creatorList = res.data;
      });
      getTagReviserList().then((res) => {
        this.reviserList = res.data;
      });
    },
    getList() {
      this.loading = true;
      const { ruleName, type, creatorList, reviserList } = this.filterData;
      queryAnalysisList({
        page: this.pageData.page,
        pageSize: this.pageData.size,
        ruleName,
        type: type.join(","),
        creatorList: creatorList.join(","),
        reviserList: reviserList.join(","),
      })
        .then((res) => {
          this.pageData.total = res.data.total;
          this.tableData = res.data.list;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    handleSearch() {
      this.pageData.page = 1;
      this.getList();
    },
    handleReset() {
      this.filterData = {
        ruleName: "",
        type: [],
        creatorList: [],
        reviserList: [],
      };
      this.handleSearch();
    },
    handleAdd() {
      this.$refs.ruleModal.openModal("add");
    },
    changePage(page) {
      this.pageData.page = page;
      this.getList();
    },
    changePageSize(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.getList();
    },
    editData(row) {
      this.$refs.ruleModal.openModal("edit", row);
    },
    copyData(row) {
      const data = JSON.parse(JSON.stringify(row));
      data.ruleName = data.ruleName + "_1";
      this.$refs.ruleModal.openModal("copy", data);
    },
    delData(row) {
      this.$confirm("确定删除该规则?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteAnalysis({ id: row.id }).then((res) => {
            if (res.code === "0000") {
              this.$message.success("删除成功");
              this.handleSearch();
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.tagname-wrap {
  border-radius: 4px;
  margin: 16px;
  box-shadow: 0 0px 10px rgba(0, 0, 0, 0.15);
  height: calc(~"100% - 38px");
  background: #ffffff;
  .header {
    height: 48px;
    line-height: 48px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    color: rgba(24, 144, 255, 1);
    padding-left: 25px;
  }
  .container {
    height: calc(~"100% - 60px");
    padding: 16px 24px;
    .filter {
      display: flex;
      .filter-item {
        margin-right: 16px;
      }
    }
    .table {
      height: calc(~"100% - 160px");
      margin-top: 12px;
    }
  }
}
</style>
